export default __webpack_public_path__ + "static/media/article-place-image.79136245.webp";